import { useFormat } from '@ideavivat/vivat-2';
import useWithdraw from '@/use/useWithdraw';

const {
  typeClassMap, translateType,
} = useWithdraw();

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    // _primaryControls: {
    //   width: '4rem',
    // },
    withdraw_request: {
      name: 'ประเภท',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: any, row: { item: { [key: string]: any }; index: number }) => row.item.broken ? translateType('BROKEN') : translateType(val?.type),
      class: {
        text(val: any, row: { item: { [key: string]: any }; index: number }) {
          return row.item.broken ? typeClassMap('BROKEN') : typeClassMap(val?.type);
        },
      },
    },
    withdraw_request_id: {
      name: 'Sub Job',
      width: '8rem',
      filter: (val: any, row: any) => row.item.withdraw_request?.code || '-',
    },
    bom_item: {
      name: 'Sub Job',
      width: '8rem',
      filter: (val: any) => val?.job_no || '-',
    },
    description: {
      name: 'Description',
      width: '1fr',
      filter: (val: string, row: any) => row.item.bom_item?.description,
    },
    amount: {
      name: 'จำนวน',
      width: '6rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    created_at: {
      name: 'วันที่ทำรายการ',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
    creator: {
      name: 'ผู้ทำรายการ',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string, row: any) => row.item.withdraw_request?.creator ? row.item.withdraw_request.creator.name : '-',
    },
  },
};
